<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      ref="tablaTiposDePases"
      :titulo="$t ('Tipos de pases')"
      icono="mdi-format-list-text"
      tabla="tippas"
      :campos="['id_tippas-', 'des+', 'id_ins', '__liszonper', 'id_tar_cobexc-', 'tipsal-']"
      :campos-filtrables="['id_ins']"
      :objeto-definicion-campos="dc_tippas"
      :objeto-registro-formulario="rf_tippas"
      busqueda-rapida
      :titulo-crud="$t ('tipo de pase')"
      altoMinimoVentana="500"
      permitir-anadir
      permitir-modificar
      permitir-eliminar
      :evento-antes-procesar-respuesta-servidor="eventoAntesProcesarRespuestaServidor"
      :evento-antes-abrir-formulario-datos="antesAbrirFormularioDatosTipoPase"
      :evento-despues-guardar-formulario-datos="despuesGuardarFormularioDatosTipoPase"
      :formulario-datos-api-props="{ anchoMaximo: '950', sinMargenes: true }"
      @montado="montadoTablaDatos"
    >
      <template v-slot:[`item.pasvis__VT`]="{ item }">
          <span v-if="item.pasvis">
            <v-icon class="mr-1">mdi-badge-account-outline</v-icon>
          </span>
          {{ item.pasvis__VT }}
      </template>

      <template v-slot:[`item.usoconres__VT`]="{ item }">
          <span v-if="item.usoconres">
            <v-icon class="mr-1">mdi-calendar-check</v-icon>
          </span>
          {{ item.usoconres__VT }}
      </template>

      <template v-slot:default="{ definicionCampos, datosRegistro, accionCrud, esAccionEliminar }">
        <div style="min-height: 350px">
        <v-tabs v-model="tab" fixed-tabs background-color="#E0E0D0" mobile-breakpoint="0">
          <!-- <v-tabs-slider color="red"></v-tabs-slider> -->
          <v-tab>
            <v-icon class="mr-3">mdi-card-bulleted-settings</v-icon>{{ $t ('Datos') }}
          </v-tab>
          <v-tab>
            <v-icon class="mr-3">mdi-select-marker</v-icon>{{ $t ('Zonas') }}
          </v-tab>
          <v-tab>
            <v-icon class="mr-3">mdi-progress-clock</v-icon>{{ $t ('Tarifas') }}
          </v-tab>
          <v-tab v-if="$parametros_configuracion.habpasren && !datosRegistro ['pasvis']">
            <v-icon class="mr-3">mdi-calendar-range</v-icon>{{ $t ('Renovaciones') }}
          </v-tab>
          <v-tab v-if="$parametros_configuracion.habpassal && !datosRegistro ['pasvis']">
            <v-icon class="mr-3">mdi-credit-card-refresh-outline</v-icon>{{ $t ('Saldo') }}
          </v-tab>
          <v-tab v-if="$parametros_configuracion.modres && datosRegistro ['id_ins'] && !datosRegistro ['pasvis']">
            <v-icon class="mr-3">mdi-calendar-check</v-icon>{{ $t ('Reservas') }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" touchless>
          <v-tab-item :eager="true" transition="scroll-x-transition">
            <v-container class="mt-5 px-6">
              <v-row no-gutters>
                <v-col cols="6">
                  <CampoFormularioDatos nombre-campo="id_ins" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
              </v-row>
              <!-- <v-row no-gutters>
                <v-col cols="6">
                  <CampoFormularioDatos nombre-campo="id_modtippas" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="'UD'.includes (accionCrud)" />
                </v-col>
              </v-row> -->
              <v-row no-gutters class="mt-2">
                <v-col>
                  <CampoFormularioDatos nombre-campo="des" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>
                  <div class="mt-8" ></div>
                  <div class="mb-2">Opciones:</div>
                  <CampoFormularioDatos nombre-campo="pasvis" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="'UD'.includes (accionCrud)" />
                  <CampoFormularioDatos nombre-campo="forasipla" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <CampoFormularioDatos nombre-campo="usoexcmot" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>

                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item :eager="true" transition="scroll-x-transition">
            <v-container class="mt-5 px-6">
              <v-row no-gutters>
                <v-col class="pb-0">
                  <CampoFormularioDatos nombre-campo="__liszonper" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item :eager="true" transition="scroll-x-transition">
            <v-container class="mt-5 px-6">
              <v-row no-gutters>
                <v-col cols="7">
                  <CampoFormularioDatos nombre-campo="id_tar_cobexc" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col class="pb-0">
                  <div class="mb-2">{{ $t ('Política de tarificación') }}</div>
                  <TablaDatosAPI
                    icono="mdi-apple-keyboard-option"
                    tabla="poltartippas"
                    :campos="['tipcon', 'id_zon', 'id_tar']"
                    :parametros="parametros_tabla_relacionada"
                    modo-memoria
                    titulo-crud="política de tarificación"
                    :permitir-anadir="!esAccionEliminar"
                    :permitir-modificar="!esAccionEliminar"
                    :permitir-eliminar="!esAccionEliminar"
                    dense
                    @cambios="cambiosEnTablaRelacionada (datosRegistro)"
                    @montado="montadoTablaDatos"
                    >
                  </TablaDatosAPI>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item v-if="$parametros_configuracion.habpasren && !datosRegistro ['pasvis']" :eager="true" transition="scroll-x-transition">
            <v-container class="mt-5 px-6">
              <v-row no-gutters>
                <v-col cols="5">
                  <CampoFormularioDatos nombre-campo="tipren" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
              </v-row>
              <v-row v-if="datosRegistro.tipren > 0" no-gutters class="mt-3">
                <v-col class="mr-5" cols="5">
                  <CampoFormularioDatos nombre-campo="tipcontraren" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <CampoFormularioDatos nombre-campo="entfuetraren" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <CampoFormularioDatos nombre-campo="diacorpagren" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <CampoFormularioDatos nombre-campo="diaantcrerenaut" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
                <v-col class="pb-0">
                  <div class="mb-2">{{ $t ('Tramos de renovación') }}</div>
                  <TablaDatosAPI
                    icono="mdi-calendar-range"
                    tabla="traren"
                    :campos="['des', '__pla', 'imp']"
                    :parametros="parametros_tabla_relacionada"
                    modo-memoria
                    titulo-crud="tramo de renovación"
                    :permitir-anadir="!esAccionEliminar"
                    :permitir-modificar="!esAccionEliminar"
                    :permitir-eliminar="!esAccionEliminar"
                    dense
                    @cambios="cambiosEnTablaRelacionada (datosRegistro)"
                    @montado="montadoTablaDatos"
                    >
                    <template v-slot:[`item.__pla`]="{ item }">
                      <span v-if="item.plames > 0">{{ item.plames }} mes(es)</span>
                      <span v-else-if="item.pladia > 0">{{ item.pladia }} día(s)</span>
                    </template>
                  </TablaDatosAPI>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item v-if="$parametros_configuracion.habpassal && !datosRegistro ['pasvis']" :eager="true" transition="scroll-x-transition">
            <v-container class="mt-5 px-6">
              <v-row no-gutters>
                <v-col cols="7">
                  <CampoFormularioDatos nombre-campo="tipsal" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="'UD'.includes (accionCrud)" />
                </v-col>
              </v-row>
              <v-row v-if="datosRegistro.tipsal > 0" no-gutters>
                <v-col class="pb-0">
                  <div class="mb-2">{{ $t ('Recargas de saldo') }}</div>
                  <TablaDatosAPI
                    icono="mdi-debug-step-over"
                    tabla="recsal"
                    :campos="['des', 'salrec', 'impcob']"
                    :parametros="parametros_tabla_relacionada"
                    modo-memoria
                    titulo-crud="recarga de saldo"
                    :permitir-anadir="!esAccionEliminar"
                    :permitir-modificar="!esAccionEliminar"
                    :permitir-eliminar="!esAccionEliminar"
                    dense
                    @cambios="cambiosEnTablaRelacionada (datosRegistro)"
                    @montado="montadoTablaDatos"
                    >
                    <template v-slot:[`item.salrec`]="{ item }">
                      {{ literalSaldoProducto (item.salrec, datosRegistro.tipsal) }}
                    </template>
                  </TablaDatosAPI>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>


          <v-tab-item v-if="$parametros_configuracion.modres && datosRegistro ['id_ins'] && !datosRegistro ['pasvis']" :eager="true" transition="scroll-x-transition">
            <v-container class="mt-5 px-6">
              <v-row no-gutters>
                <v-col class="pb-0">
                  <CampoFormularioDatos nombre-campo="usoconres" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <CampoFormularioDatos nombre-campo="percespla" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

        </v-tabs-items>
        </div>
      </template>
    </TablaDatosAPI>

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";
import CampoFormularioDatos from '@/components/CampoFormularioDatos.vue'
import api from '@/api'
import utilAris from "@/utilAris";

export default {
  components: { TablaDatosAPI, CampoFormularioDatos },
  data() {
    return {
      tablasDatos: [],
      tab: 0,
      dc_tippas: {},
      rf_tippas: {}
    }
  },
  computed: {
    parametros_tabla_relacionada() {
      return {
        idTipoPase: { valor: this.rf_tippas ['id_tippas'] ?? 0, // this.tablasDatos['tippas'].formulario.datosRegistro ['id_tippas'] ?? 0
                      descripcion: '' }
      };
    }
  },
  methods: {
    montadoTablaDatos (tablaDatos) {
      this.tablasDatos [tablaDatos.tabla] = tablaDatos;
    },
    cambiosEnTablaRelacionada (datosRegistroTipoPase) {
      if (this.tablasDatos ['poltartippas'].hayCambiosModoMemoria() || this.tablasDatos ['traren'].hayCambiosModoMemoria() || this.tablasDatos ['recsal'].hayCambiosModoMemoria())
        this.$set (datosRegistroTipoPase, 'ctr__AUX', true); // ctr = Cambios en Tabla relacionada
      else
        this.$delete (datosRegistroTipoPase, 'ctr__AUX');
    },
    despuesGuardarFormularioDatosTipoPase () {
      let loteCambios = null;

      if (this.tablasDatos ['traren']) {
        loteCambios = this.tablasDatos ['traren'].loteCambiosRegistros((registro) => { registro.id_tippas = this.rf_tippas ['id_tippas'] });
        if (loteCambios.cambios)
          api.loteCambiosRegistrosTablaVista ('traren', loteCambios);
      }

      if (this.tablasDatos ['recsal']) {
        loteCambios = this.tablasDatos ['recsal'].loteCambiosRegistros((registro) => { registro.id_tippas = this.rf_tippas ['id_tippas'] });
        if (loteCambios.cambios)
          api.loteCambiosRegistrosTablaVista ('recsal', loteCambios);
      }

      if (this.tablasDatos ['poltartippas']) {
        loteCambios = this.tablasDatos ['poltartippas'].loteCambiosRegistros((registro) => { registro.id_tippas = this.rf_tippas ['id_tippas'] });
        if (loteCambios.cambios)
          api.loteCambiosRegistrosTablaVista ('poltartippas', loteCambios);
      }
    },
    eventoAntesProcesarRespuestaServidor (definicionCampos) {
      if (definicionCampos) {
        definicionCampos ['pasvis'].visibilidad = this.$parametros_configuracion.modvisempinq ? '' : '-' ;
        definicionCampos ['usoconres'].visibilidad = this.$parametros_configuracion.modres ? '' : '-' ;
        definicionCampos ['percespla'].visibilidad = this.$parametros_configuracion.modres ? '' : '-' ;
        definicionCampos ['tipsal'].visibilidad = this.$parametros_configuracion.habpassal ? '' : '-';
      }
    },
    antesAbrirFormularioDatosTipoPase () {
      this.tab = 0;
    },
    cambiosEnRegistro (dr) {
      this.$set (this.dc_tippas ['pasvis'], "visible_en_formulario", dr['id_ins']);
      this.$set (this.dc_tippas ['tipsal'], "visible_en_formulario", !dr['pasvis']);
      this.$set (this.dc_tippas ['usoconres'], "visible_en_formulario", dr['id_ins'] && !dr['pasvis']);
      this.$set (this.dc_tippas ['percespla'], "visible_en_formulario", dr['id_ins'] && !dr['pasvis'] && !dr['usoconres'] && (dr['__liszonper'].length < 2));
    },
    ...utilAris,
  },
  mounted() {
    this.$watch ("rf", { handler: this.cambiosEnRegistro, deep: true });
  }
};
</script>

<style>
</style>